import {Solutions} from '../../app/models/environment-configuration';

export const BELTRAME_COMMON_ENV = {
  SOLUTION: Solutions.BELTRAME,
};
